import { Button, SaveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";

import { useConfirm} from "melco-shared-logic";

import { useFormikContext } from "formik";



type EditLocaleStringsConfirmButtonProps = {
   
};

export const EditLocaleStringsConfirmButton: React.FC<
    EditLocaleStringsConfirmButtonProps
> = () => {
    const { t } = useTranslation();
   
    const {  submitForm, values } = useFormikContext();
   
    const confirmGenerate = useConfirm(
        async () => {
          
            submitForm();
            
          
        },
        {
            translationPrefix: [
                "localestrings.actions",
                "update",
            ].join("."),
  }
    );

  return (

        <>
        <Button
            icon={<SaveIcon />}
            type="primary"

            onClick={(values) => {
              
             confirmGenerate();

            }}
          >
            {t("localestrings.actions.update.button")}
          </Button></>
    );
};
